import { setNavigationBar } from '@docs/common'
import { useEffect } from 'react'

function PageNotFound() {
  useEffect(() => {
    setNavigationBar({
      title: 'Page not found.',
      hidden: false,
    })
  }, [])

  return (
    <h2 style={{ textAlign: 'center' }}>
      Page not found.
    </h2>
  )
}

export default PageNotFound
